import { StandardEvents } from '@shopify/events';

/**
 * Vervangt de inhoud van het varianttekst-blok wanneer een andere variant
 * wordt gekozen. De nieuwe inhoud komt uit de opnieuw gerenderde sectie.
 */
class VariantTextComponent extends HTMLElement {
  #target = null;

  connectedCallback() {
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], .shopify-section, dialog');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        const fresh = html.querySelector(`variant-text-component[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-text]', error);
      });
  };
}

if (!customElements.get('variant-text-component')) {
  customElements.define('variant-text-component', VariantTextComponent);
}
